/* PORTED VERBATIM from mondain-html/assets/shop.js (parity, 2026-08-29).
   Data seam unchanged: provider() reads window.MDN_CATALOGUE, which the
   layout renders from snippets/mondain-catalogue.liquid on EVERY page (the
   search lives in the header). Keep in lockstep with the gold file. */
/* =========================================================================
   MONDAIN — the SHOP engine: live search + faceted filtering rendering a
   product grid inside the header's search expansion, on every page.

   Seamas (2026-08-15, the standing goal): "improving search/filtering for
   the determined shopper. the filters should dynamically render a page of
   filtered items so that 'home' can also be the 'shop all' / 'collections'
   workflow when we hook this WIP up to Shopify in the future. So when a
   search query is entered or filters are selected, I'd like the relevant
   products to load in automatically. behind the search bar, replacing the
   current 'text only dropdown list' you currently have in search."

   DESIGN DECISIONS (v2, 2026-08-17 — Seamas, with screenshot: "product
   cards should NOT show up within the search / filtering modal. If an item
   is searched / filtered for, product cards appear behind the search bar as
   a collection list that fills in behind the search. Just product cards and
   the mondain logo (from home panel 1, but this time in Black) at the top
   of the screen"):

   - The MODAL holds only the controls: the field, the count/sort/clear
     toolbar, the facet rows. No cards inside the glass, ever.
   - The RESULTS are a full COLLECTION PAGE (.mdn-shop-page) fixed behind
     the header: the HOME hero scrawl at the top — in ink, not white — then
     nothing but product cards. It exists only while a query or filter is
     active; open-with-nothing-asked shows no cards anywhere.
   - Query + facets compose: the query matches title/colour/type/tags, facet
     groups are OR within a group and AND across groups, re-rendered per
     keystroke — 35 records need no debounce, no index, no cleverness.
   - Sort is explicit (Featured = catalogue order / price both ways).
   - Enter or the send arrow goes to the first card's PDP.
   - Closing the search puts the page away with it (the shell owns
     data-open; this file only watches it).

   THE SHOPIFY SEAM: everything below reads products through provider().
   Today that resolves window.MDN_CATALOGUE (assets/catalogue.js, whose
   records already mirror Storefront API fields — the mapping table is in its
   header). The hook-up replaces provider() with a Storefront query (or a
   cached copy of one) and maps facet selections onto productType / tag /
   availableForSale filters; nothing in the rendering or filtering below
   needs to know the data went live.

   The shell owns the search FRAME (toggle, expansion, focus, Escape —
   shell.js); this file only fills the body. The old text-only result list
   that lived here before is tombstoned in shell.js.
   ========================================================================= */

(function () {
  'use strict';

  window.MDNShop = { ownsSearch: true };   /* read by shell.js's tombstone */

  function provider() {
    var c = window.MDN_CATALOGUE;
    var all = (c && c.products) ? c.products : [];
    /* teaser cards stand in for unreleased products on HOME; nothing to shop */
    return all.filter(function (p) { return !p.teaser; });
  }

  var FACETS = [
    /* the terms are the real catalogue's vocabulary (2026-08-18: the fake
       hats/coats/eyewear placeholders left with the placeholder products) */
    { key: 'type', label: 'Type',
      terms: ['Tees', 'Hoodies', 'Long Sleeves', 'Tanks', 'Prints', 'Objects'],
      of: function (p) { return [p.type]; } },
    { key: 'colour', label: 'Color',
      terms: ['Black', 'Faded Black', 'Off White', 'White', 'Heather Grey',
              'Light Grey', 'Charcoal Grey', 'Slate Blue',
              'Cerulean Blue', 'Vintage Yellow'],
      of: function (p) { return [p.colour]; } },
    { key: 'size', label: 'Size',
      terms: ['S', 'M', 'L', 'XL', 'XXL', '8×12″', '16×24″', '24×36″', '32×48″', '40×60″', '52″ × 37″'],
      of: function (p) { return p.sizes; } },
    { key: 'stock', label: 'Stock',
      terms: ['In stock'],
      of: function (p) { return p.available ? ['In stock'] : []; } }
  ];

  function money(cents) {
    var whole = Math.floor(cents / 100);
    var frac = cents % 100;
    return '$' + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      (frac ? '.' + String(frac).padStart(2, '0') : '');
  }

  function init() {
    var search = document.getElementById('mdn-search');
    if (!search) return;
    var form = search.querySelector('.mdn-search__field');
    var input = search.querySelector('.mdn-search__input');
    var body = search.querySelector('.mdn-search__body');
    if (!form || !input || !body) return;
    if (!provider().length) return;        /* catalogue.js missing: leave the
                                              field alone rather than break it */

    /* ---- chrome: toolbar, facets, grid --------------------------- */

    var facetsHtml = '';
    for (var g = 0; g < FACETS.length; g++) {
      var chips = '';
      for (var c = 0; c < FACETS[g].terms.length; c++) {
        var term = FACETS[g].terms[c];
        chips += '<button class="m-chip" type="button" aria-pressed="false"' +
          ' data-facet="' + FACETS[g].key + '" data-term="' + term + '">' +
          term + '</button>';
      }
      facetsHtml += '<div class="mdn-shop__fgroup">' +
        '<span class="mdn-shop__flabel m-micro">' + FACETS[g].label + '</span>' +
        '<div class="mdn-shop__fchips">' + chips + '</div></div>';
    }

    var chrome = document.createElement('div');
    chrome.innerHTML =
      '<div class="mdn-shop__toolbar">' +
        '<span class="mdn-shop__count m-micro" data-shop-count></span>' +
        '<div class="mdn-shop__sorts" role="group" aria-label="Sort">' +
          '<button class="m-chip" type="button" aria-pressed="true" data-sort="featured">Featured</button>' +
          '<button class="m-chip" type="button" aria-pressed="false" data-sort="asc">Price ↑</button>' +
          '<button class="m-chip" type="button" aria-pressed="false" data-sort="desc">Price ↓</button>' +
        '</div>' +
        '<button class="m-chip mdn-shop__clear" type="button" data-shop-clear hidden>Clear all</button>' +
      '</div>' +
      '<div class="mdn-shop__facets" aria-label="Filters">' + facetsHtml + '</div>';
    while (chrome.firstChild) body.appendChild(chrome.firstChild);

    /* the collection page: fixed behind the header, the hero scrawl in ink
       at the top, then cards and nothing else. Hidden until asked. */
    var page = document.createElement('div');
    page.className = 'mdn-shop-page';
    page.hidden = true;
    page.setAttribute('aria-label', 'Search results');
    page.innerHTML =
      '<span class="mdn-shop-page__mark mdn-mark mdn-mark--word" aria-hidden="true"></span>' +
      /* the collection's own bar: orientation and exits that survive the
         modal collapsing — count, a way back into the filters, a way out */
      '<div class="mdn-shop-page__bar m-micro">' +
        '<span data-shop-page-count></span>' +
        '<button class="m-chip" type="button" data-shop-filters>Filters</button>' +
        '<button class="m-chip" type="button" data-shop-page-clear>Clear all</button>' +
      '</div>' +
      '<div class="mdn-shop__grid" data-shop-grid aria-live="polite"></div>';
    document.body.appendChild(page);

    var grid = page.querySelector('[data-shop-grid]');
    var count = body.querySelector('[data-shop-count]');
    var clear = body.querySelector('[data-shop-clear]');
    var chipEls = [].slice.call(body.querySelectorAll('[data-facet]'));
    /* THEME SEAM: a facet term nothing in the live catalogue answers to is
       hidden (the gold vocabulary includes the parked Gallery's Prints and
       print sizes). Purely presentational — the matching is untouched. */
    (function pruneEmptyTerms() {
      var all = provider();
      for (var c = 0; c < chipEls.length; c++) {
        var chip = chipEls[c], group = null;
        for (var f = 0; f < FACETS.length; f++) if (FACETS[f].key === chip.getAttribute('data-facet')) group = FACETS[f];
        if (!group) continue;
        var term = chip.getAttribute('data-term'), hit = false;
        for (var i = 0; i < all.length && !hit; i++) hit = group.of(all[i]).indexOf(term) !== -1;
        if (!hit) { chip.hidden = true; chip.style.display = 'none'; }   /* .m-chip's own display beats the UA's [hidden] */
      }
    })();
    var sortEls = [].slice.call(body.querySelectorAll('[data-sort]'));
    var sort = 'featured';
    /* SHOP ALL (Seamas, 2026-09-18: /collections/all "needs to route to the
       search all products with filters open"): arriving on #shop shows the
       whole catalogue behind the open filters, as if every filter matched.
       Clear all / Escape put the page back. */
    var showAll = /^#(shop|all)$/.test(window.location.hash);

    /* ---- the model ------------------------------------------------ */

    function selection() {
      var byGroup = {};
      for (var i = 0; i < chipEls.length; i++) {
        if (chipEls[i].getAttribute('aria-pressed') !== 'true') continue;
        var key = chipEls[i].getAttribute('data-facet');
        (byGroup[key] = byGroup[key] || []).push(chipEls[i].getAttribute('data-term'));
      }
      return byGroup;
    }

    function passes(product, byGroup) {
      for (var key in byGroup) {
        if (!Object.prototype.hasOwnProperty.call(byGroup, key)) continue;
        var group = null;
        for (var f = 0; f < FACETS.length; f++) if (FACETS[f].key === key) group = FACETS[f];
        if (!group) continue;
        var values = group.of(product);
        var any = false;
        for (var i = 0; i < byGroup[key].length && !any; i++) {
          any = values.indexOf(byGroup[key][i]) !== -1;
        }
        if (!any) return false;
      }
      return true;
    }

    function matches(product, q) {
      if (!q) return true;
      var hay = (product.title + ' ' + product.colour + ' ' + product.type + ' ' +
                 product.tags.join(' ')).toLowerCase();
      var words = q.split(/\s+/);
      for (var i = 0; i < words.length; i++) {
        if (hay.indexOf(words[i]) === -1) return false;
      }
      return true;
    }

    function results() {
      var q = input.value.trim().toLowerCase();
      var byGroup = selection();
      var out = [];
      var all = provider();
      for (var i = 0; i < all.length; i++) {
        if (matches(all[i], q) && passes(all[i], byGroup)) out.push(all[i]);
      }
      if (sort !== 'featured') {
        out.sort(function (a, b) {
          return sort === 'asc' ? a.price - b.price : b.price - a.price;
        });
      }
      return out;
    }

    /* ---- the view ------------------------------------------------- */

    function card(p) {
      return '<a class="mdn-shop__card" href="' + p.url + '">' +
        '<span class="mdn-shop__art">' +
          (p.img
            ? '<img class="mdn-shop__photo" src="' + p.img.back + '" alt="" loading="lazy" draggable="false">' +
            '<span class="mdn-card__buy m-micro" aria-hidden="true">Buy now</span>'
            : '<span class="mdn-ph" data-ph="' + p.ph + '"></span>') +
          (p.flag ? '<span class="mdn-shop__flag m-micro">' + p.flag + '</span>' : '') +
        '</span>' +
        '<span class="mdn-shop__meta">' +
          '<span class="mdn-shop__name m-micro-sans">' + p.title + '</span>' +
          '<span class="mdn-shop__price m-micro">' + money(p.price) + '</span>' +
          '<span class="mdn-shop__colour m-micro-sans">' + p.colour + '</span>' +
        '</span>' +
      '</a>';
    }

    function render() {
      var hits = results();
      var filtering = showAll || input.value.trim() !== '' ||
        body.querySelector('[data-facet][aria-pressed="true"]') !== null;
      count.textContent = filtering
        ? hits.length + (hits.length === 1 ? ' item' : ' items')
        : '';
      clear.hidden = !filtering && sort === 'featured';

      pageCount.textContent = count.textContent;

      /* the page exists only while something is asked of it */
      if (!filtering) {
        page.hidden = true;
        root.removeAttribute('data-mdn-shop');
        grid.innerHTML = '';
        return;
      }
      page.hidden = false;
      /* the flag lets shop.css disarm HOME's hero wordmark link — invisible
         white-on-white above this overlay, it was swallowing clicks at the
         collection's top centre and navigating to index.html ("if you click
         anywhere it... redirects back to home") */
      root.setAttribute('data-mdn-shop', '');
      clearModal();
      if (!hits.length) {
        grid.innerHTML = '<p class="mdn-shop__empty m-micro">No matches — ' +
          'try “hoodie”, “print”, or clear the filters</p>';
        return;
      }
      var html = '';
      for (var i = 0; i < hits.length; i++) html += card(hits[i]);
      grid.innerHTML = html;
    }

    /* the collection starts BELOW the open modal — the scrawl must be the
       first thing on the page, not a shape hiding behind the glass. The
       modal's height moves with facet wrapping, so this is measured, not
       assumed. */
    function clearModal() {
      var glass = document.getElementById('mdn-header');
      if (!glass) return;
      page.style.paddingTop = Math.round(glass.getBoundingClientRect().bottom + 22) + 'px';
    }
    window.addEventListener('resize', function () {
      if (!page.hidden) clearModal();
    }, { passive: true });

    /* SMART COLLAPSE (Seamas: "if scrolling the filtering menu blocks the
       entire page... We need the menu to smart collapse if the user starts
       scrolling downwards to preserve shopability"). The modal and the
       collection are decoupled now: closing the search COLLAPSES THE
       CONTROLS, the collection stays until the filters are cleared. */

    var root = document.documentElement;
    var toggle = document.querySelector('[data-mdn-search-toggle]');
    var pageCount = page.querySelector('[data-shop-page-count]');

    function modalOpen() { return search.getAttribute('data-open') === 'true'; }
    function collapseModal() {
      if (modalOpen() && toggle) {
        toggle.click();
        /* the glass shrinks on close; re-measure the page's top padding
           once it has settled so the first scroll doesn't leave a stale
           gap that reads as a jump (Seamas, 2026-09-03) */
        setTimeout(clearModal, 360);
      }
    }

    /* scrolling down into the results folds the controls away; the padding
       re-measures so the grid rises into the reclaimed room */
    var lastTop = 0;
    page.addEventListener('scroll', function () {
      var top = page.scrollTop;
      if (top > lastTop + 8 && top > 24) collapseModal();
      lastTop = top;
    }, { passive: true });

    /* a wheel-down on the glass itself means "get on with the shopping" —
       without this the modal ate the gesture and the page felt blocked */
    search.addEventListener('wheel', function (e) {
      if (!page.hidden && e.deltaY > 0) collapseModal();
    }, { passive: true });

    page.querySelector('[data-shop-filters]').addEventListener('click', function () {
      if (!modalOpen() && toggle) toggle.click();
    });

    /* CLEAN EXIT (2026-08-27, Seamas: "opening/closing/scrolling with
       search bar present/filtering menu is buggy"). The contract now:
       - scrolling the results COLLAPSES the controls (collection stays)
       - Escape EXITS the shop entirely — controls, collection, state
       Before this, Escape closed only the glass and left the collection
       pinned over a page whose own scroll kept moving underneath. */
    function exitShop() {
      showAll = false;
      if (input) input.value = '';
      for (var i = 0; i < chipEls.length; i++) {
        chipEls[i].setAttribute('aria-pressed', 'false');
      }
      page.scrollTop = 0;
      render();
      collapseModal();
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !page.hidden) exitShop();
    });
    page.querySelector('[data-shop-page-clear]').addEventListener('click', function () {
      clear.click();
    });

    /* modal state changes re-measure the clearance either way; only an OPEN
       modal re-renders (the collection persists through a collapse) */
    new MutationObserver(function () {
      if (modalOpen()) render();
      /* measure once immediately, and again after the glass has finished
         folding — the expansion animates, and a single early measure froze
         the clearance at a mid-collapse height (probed: 501px) */
      window.requestAnimationFrame(clearModal);
      window.setTimeout(clearModal, 450);
    }).observe(search, { attributes: true, attributeFilter: ['data-open'] });

    /* ---- wiring --------------------------------------------------- */

    for (var i = 0; i < chipEls.length; i++) {
      (function (chip) {
        chip.addEventListener('click', function () {
          chip.setAttribute('aria-pressed',
            chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          render();
        });
      })(chipEls[i]);
    }

    for (var s = 0; s < sortEls.length; s++) {
      (function (el) {
        el.addEventListener('click', function () {
          sort = el.getAttribute('data-sort');
          for (var j = 0; j < sortEls.length; j++) {
            sortEls[j].setAttribute('aria-pressed', String(sortEls[j] === el));
          }
          render();
        });
      })(sortEls[s]);
    }

    clear.addEventListener('click', function () {
      showAll = false;
      input.value = '';
      for (var j = 0; j < chipEls.length; j++) chipEls[j].setAttribute('aria-pressed', 'false');
      sort = 'featured';
      for (var k = 0; k < sortEls.length; k++) {
        sortEls[k].setAttribute('aria-pressed', String(sortEls[k].getAttribute('data-sort') === 'featured'));
      }
      render();
      input.focus();
    });

    input.addEventListener('input', render);

    /* Enter / the send arrow: straight to the first card's PDP */
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var first = grid.querySelector('a');
      if (first) window.location.href = first.getAttribute('href');
    });

    render();   /* the shop-all state — full before anything is asked of it */
    /* #shop: the filters up, the catalogue behind. The toggle is wired by
       shell.js, which runs after this file — so open once the page has
       loaded, not now. */
    function openShopAll() { if (showAll && !modalOpen() && toggle) toggle.click(); }
    if (document.readyState === 'complete') window.setTimeout(openShopAll, 0);
    else window.addEventListener('load', function () { window.setTimeout(openShopAll, 0); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
